import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ScreenContainer from '../../components/ScreenContainer';
import Header from '../../components/Header';
import Button from '../../components/Button';
import RightArrow from '../../icons/RightArrow';
import { typography } from '../../styles/typography';
import colors from '../../styles/colors';
import Footer from '../../components/Footer';
import { signInWithCustomToken } from 'firebase/auth';
import { auth, timestampToDate } from '../../services/firebase';
import { getUserInfo } from '../../services/firestore';
import { ANNUAL } from '../../constans';
import useAuth from '../../hooks/useAuth';
import { isTesting } from '../../utils/Generic';
import { userActive } from '../../mock/user';
import SubscriptionStatus from '../../components/SubscriptionStatus';
import { t } from 'i18next';
import { useAppContext } from '../../store/AppContext';


export default function Account() {
  const [loading, setLoading] = useState(null);
  const { state, setUser } = useAppContext()
  const user = state?.user
  const [authInitialized, authUser] = useAuth()
  const navigate = useNavigate();

  function trans(key, options) {
    return t("eyearywebhome_" + key, options)
  }

  function setUserData(uid) {

    getUserInfo(uid).then((data) => {
      setUser(data)
    }).catch((e) => {
      console.error(e)
      window.location.href = "/error"
    })
    setLoading(false)
    window.history.replaceState({}, document.title, "/account");
  }

  useEffect(() => {
    if (isTesting()) return
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    if (token) {
      signInWithCustomToken(auth, token).then((result) => {
        setUserData(result.user.uid)
      }).catch((e) => {
        window.location.href = "/error"
      });
    } else {
      if (authInitialized) {
        if (!authUser)
          window.location.href = "/error"
        else
          setUserData(authUser.uid)
      }

    }
  }, [authInitialized, authUser])

  if (!user) return <div>Loading...</div>

  return (
    <ScreenContainer style={style.container}>
      <Header withBackButton={false} />
      <div className={"scrollContainer"} style={style.scrollContainer}>

        <h1 className={"title title_m_24_medium"}>{trans(0)}</h1>

        <label style={style.subtitle} className='mt-48'>{trans(1)}</label>
        <div style={style.card}>
          <div style={style.cardContent}>
            <SubscriptionStatus titleStyle={{ color: '#fff' }} />
          </div>

          {/* <div style={style.cardContent}>
            <div style={style.cardTitle}>멤버십: </div>
            <div style={style.freeTrial} className='mt-4'>
              {`${["trialing", "active"].includes(user.subscription.status) ? "리커버리 모드" : "Protection 모드"}
              ${user.subscription.isTrial ? " - 해지 예정 - " : " "}
              ${["trialing", "active"].includes(user.subscription.status) ? (user.subscription.plan == ANNUAL ? `연간 플랜($${user.subscription.amount})/년` : `월간 플랜($${user.subscription.amount})/월`) : ""}`}</div>
            <div style={style.freeTrial} className='mt-4'>{`이용 시작일: ${timestampToDate(user.createDate).toDateString()}`}</div>
            <div style={style.freeTrial} className='mt-4'>{`체험 종료일 : ${new Date(user.subscription.trialEnd * 1000).toDateString()}`}</div>
            {user.subscription.isTrial && <div style={style.freeTrial} className='mt-4'>{'체험 종료 후, 프로텍션 모드로 자동 전환 예정'}</div>}
          </div> */}
          <Button
            text={trans(3)}
            style={style.btn}
            onClick={() => navigate("/mode_change")}
          >
            <RightArrow />
          </Button>
          <Button
            text={trans(4)}
            style={style.btn}
            onClick={() => navigate("/plan_change")}
          >
            <RightArrow />
          </Button>
          <Button
            text={trans(5)}
            style={style.btn} >
            <RightArrow />
          </Button>
          <Button
            text={trans(6)}
            style={style.btn} >
            <RightArrow />
          </Button>

        </div>
        <label style={style.subtitle} className='mt-40'>{trans(7)}</label>
        <div style={style.card}>
          <Button
            text={trans(7)}
            style={{ ...style.btn, borderTop: '0px solid transparent' }}
            onClick={() => window.location.href = '/customer_service'}
          >
            <RightArrow />
          </Button>
        </div>

        <label style={style.subtitle} className='mt-40'>{trans(9)}</label>
        <div style={{ ...style.card, padding: 16 }}>
          <div style={style.cardTitle}>{trans(10)} </div>
          <div style={style.freeTrial}>{user.email}</div>
        </div>
        <Footer style={{ marginTop: 150 }} />
      </div>

    </ScreenContainer>

  );
}

const style = {
  container: {
    height: '100vh',
    overflow: 'hidden'
  },
  scrollContainer: {
    alignItems: 'flex-start',
    overflowY: 'scroll',
  },
  card: {
    backgroundColor: '#111D22',
    border: '1px solid transparent',
    borderRadius: 13,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',

  },
  cardOn: {
    backgroundColor: '#071A21',
    border: `1px solid ${colors.secondaryColor500}`
  },
  cardContent: {
    color: '#fff',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    padding: 16
  },
  freeTrial: {
    color: colors.mono300
  },
  subtitle: {
    ...typography.body['14_regular'],
    color: colors.mono300,
    width: '100%',
    marginBottom: 10
  },
  cardTitle: {
    ...typography.title.s_18_medium,
    color: '#FFF',
  },
  btn: {
    ...typography.body['15_regular'],
    color: colors.white,
    width: '100%',
    justifyContent: 'space-between',
    paddingTop: 16,
    paddingBottom: 16,
    borderTop: `1px solid ${colors.surfaceBorderColor}`,
    borderRadius: 0,
    paddingLeft: 16,
    paddingRight: 20
  }
}